import React, { useEffect, useReducer, useState } from 'react';
import login_unilever_2 from "../../assets/images/login-unilever-2.svg";
// import email_icon from "../../assets/images/email-icon.svg";
import Login_bg_1 from "../../assets/images/login-bg-1.png";
import Button from "@material-ui/core/Button";
import AuthMiddleware from "../../store/middleware/authMiddleware";
import { connect,  useDispatch } from "react-redux";
import './style.scss'
import $ from 'jquery'

const initialState = {
    error: {}
}

function reducer(state, action) {
    switch (action.type) {
        case 'ON_ERROR':
            return { ...state, error: { ...action.payload } }
        default:
            return state;
    }
}

function ChangePassword(props) {

    const [email, setEmail] = useState('');
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [state, dispatch] = useReducer(reducer, initialState)
    // const store = useSelector(store => store)
    const dispatch_ = useDispatch()

    useEffect(() => {
        setEmail(props.location.state.email)
    }, [props.location.state.email])
    $(document).ready(function() {
        $('#mypassword').bind("cut copy paste", function(e) {
            e.preventDefault();
                alert("You cannot paste into this text field.");
            $('#mypassword').bind("contextmenu", function(e) {
                e.preventDefault();
            });
        });
    });
    function handleChangePassword() {
        const isValidate = checkValidation()
        if (isValidate) {
            const body = {
                password: newPassword,
                oldPassword: currentPassword,
                email: email
            }
            dispatch_(AuthMiddleware.userChangePassword(body, props.location.state.userId, props.location.state.access_token, props.history))
        }
    }

    function checkValidation() {
        const error = {};
        if (!currentPassword.trim()) {
            error.currentPassword = 'Please enter current password'
        }
        if (!newPassword.trim()) {
            error.newPassword = 'Please enter new password'
        } else {
            if (newPassword.trim().length < 8) {
                error.newPassword = 'New password must be greater or equal to 8'
            }
        }
        if (!confirmPassword.trim()) {
            error.confirmPassword = 'Please enter confirm password'
        }
        if (confirmPassword !== newPassword) {
            error.passwordMatch = 'New password and confirm password not match'
            error.newPassword = 'New password must be greater or equal to 8'
        }

        console.log(error)
        dispatch({ type: 'ON_ERROR', payload: error })

        return !Object.keys(error).length
    }

    return (
        <div className="container-fluid main-verifyEmail-container">
            {console.log(props.isLoading)}
            <div className=" main-verifyEmail">
                <div className=" verifyEmail-container-left">
                    <div className=" verifyEmail-container-left">
                        <div className="verifyEmail-bg-1">
                            <img src={Login_bg_1} alt='' />
                            <div className="verifyEmail-bg-2">
                                <img src={login_unilever_2} alt='' />
                            </div>
                        </div>
                    </div>
                </div>
                <div className=" verifyEmail-container-right">
                    <div style={{ margin: '10px', display: 'flex', flexDirection: 'column', padding: '20px' }}>
                        <div style={{ alignSelf: 'end' }}><h2 style={{ fontSize: '30px', fontWeight: 'normal', fontFamily: 'Source Sans Pro,sans-serif', }}>Change Your Password</h2></div>
                        <form>
                            <div className="login-textfields">
                                <label>Email</label>
                                <input
                                    autoComplete="on"
                                    name="email"
                                    value={email}
                                    // onChange={(e) => this.handleChange(e)}
                                    // onKeyDown={(e) => this.handleEnter(e)}
                                    placeholder="Email"
                                    disabled={true}
                                    required
                                ></input>
                                <label>Old Password</label>
                                <input
                                    autoComplete="on"
                                    type="password"
                                    id="mypassword"
                                    name="password"
                                    value={currentPassword}
                                    //   onKeyDown={(e) => this.handleEnter(e)}
                                    onChange={(e) => setCurrentPassword(e.target.value)}
                                    placeholder="Password"
                                    required
                                ></input>
                                {state.error.currentPassword && <span className="error">{state.error.currentPassword}</span>}
                                <label>New Password</label>
                                <input
                                    autoComplete="on"
                                    type="password"
                                    name="password"
                                    id="mypassword"
                                    value={newPassword}
                                    //   onKeyDown={(e) => this.handleEnter(e)}
                                    onChange={(e) => setNewPassword(e.target.value)}
                                    //   onChange={(e) => this.handleChange(e)}
                                    placeholder="Password"
                                    required
                                ></input>
                                {state.error.newPassword && <span className="error">{state.error.newPassword}</span>}
                                <label>Confirm New Password</label>
                                <input
                                    autoComplete="on"
                                    type="password"
                                    name="password"
                                    id="mypassword"
                                    value={confirmPassword}
                                    //   onKeyDown={(e) => this.handleEnter(e)}
                                    //   onChange={(e) => this.handleChange(e)}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                    placeholder="Password"
                                    required
                                ></input>
                                {state.error.confirmPassword && <span className="error">{state.error.confirmPassword}</span>}
                                {state.error.passwordMatch && <span className="error">{state.error.passwordMatch}</span>}
                                <Button
                                    variant="outlined"
                                    className="login-btn"
                                    //   onClick={(e) => this.handleLogin(e)}
                                    onClick={handleChangePassword}
                                //   disabled={this.props.isLoading}
                                >
                                    {props.isLoading ? "Changing Password..." : "Change Password"}
                                </Button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}


const mapStateToProps = (state) => {
    return {
        isLoading: state.AuthReducer.isLoading,
    };
};

// const mapDispatchToprops = (dispatch) => {
//     return {
//         userChangePassword: (username, password, history) => {
//             dispatch(AuthMiddleware.userChangePassword(username, password, history));
//         },
//     };
// };

export default connect(mapStateToProps, null)(ChangePassword);
